import axios from 'axios';
import { getOrgAddressDefaults } from './countriesStates';

export { getOrgAddressDefaults };

/** Load country/state defaults from Org Admin → Org Settings. */
export async function loadOrgAddressDefaults(organizationId) {
  if (!organizationId) return getOrgAddressDefaults(null);
  try {
    const response = await axios.get(`/api/organizations/${organizationId}`);
    return getOrgAddressDefaults(response.data);
  } catch (error) {
    console.error('Error loading org address defaults:', error);
    return getOrgAddressDefaults(null);
  }
}
